import { Box, Theme, SxProps, Typography } from '@mui/material';

type SectionHeaderProps = Readonly<{
  title: string;
  description: string;
  actions?: React.ReactNode;
}>;

export const SectionHeader = ({ title, description, actions }: SectionHeaderProps) => {
  return (
    <Box sx={containerSx}>
      <Box sx={textContainerSx}>
        <Typography variant="text-lg-semibold" color={(theme) => theme.backrs.colors['Gray/900']}>
          {title}
        </Typography>
        <Typography variant="text-sm-regular" color={(theme) => theme.backrs.colors['Gray/600']}>
          {description}
        </Typography>
      </Box>

      {actions}
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  mt: backrs.spacing['spacing-4xl'],
  mb: backrs.spacing['spacing-md'],
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

const textContainerSx: SxProps<Theme> = ({ backrs }) => ({
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: backrs.spacing['spacing-xxs'],
  mb: backrs.spacing['spacing-lg'],
});
